import React, { useEffect, useState, useRef } from "react";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaArrowLeftLong,
} from "react-icons/fa6";
import { ENABLE_NOTIFY_USERS } from "../../../../constants/env";
import { MdDelete, MdClose } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import backgroundImagePlaceholder from "../../../../assets/images/elementor-placeholder-image.webp";
import { history } from "../../../../store/configure/configureStore";
import { COMMON_STOP_WORDS } from "../../../../constants/constants";
import { youtubeUrlConstants } from "../../../../store/YouTubeManagement/YouTubeManagementReducer";
import YouTube from "react-youtube";
// import queryString from "query-string";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  TagView,
  ModalView,
  FileInput,
  TextArea,
} from "../../../controls";
import { Role } from "../../../../constants/role";
//
import "./ContentDetailsStyles.scss";

const ContentDetailsView = ({
  fields,
  youtubeList,
  genres,
  errors,
  page,
  limit,
  languages,
  activeNavTab,
  editor,
  showSelection,
  showModal,
  //
  handleTitleChange,
  handleDescriptionChange,
  handleCategoryChange,
  handleStatusChange,
  handleLanguageChange,
  handleSubCategoryChange,
  handleGenreChange,
  handleAddMultipleTagList,
  handleRemoveGenre,
  autoFillValue,
  handleInputChange,
  handleFileChange,
  handleRemoveFile,
  //
  onClickSendNotification,
  onClickImageTitle,
  onClickDeleteFile,
  handleCloseModal,
  //
  handelUpdateIds,
  handleInitialGenres,
  //
  onClickAddTag,
  onClickContentDetailsSubmit,
  onClickNotify,
  onClickCancelButton,
  //
  categoryDropDownOptions,
  statusDropDownOptions,
  tagDropDownOptions,
  LanguagesDropDownOptions,
  //
  userRole,
  userPermissions,
  //
  onClickCancel,
}) => {
  // console.log("fieldsstatus", fields["status"]);
  console.log("fields", fields);

  // console.log("fields?.metaData", fields?.metaData);
  const [genreValue, setGenreValue] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [inputValueSubCategory, setInputSubCategoryValue] = useState("");
  const [subCategoryValue, setSubCategoryValue] = useState([]);
  const [viewOnly, setViewOnly] = useState(false);

  useEffect(() => {
    if (userRole === Role.Viewer) {
      setViewOnly(true);
    }

    autoFillValue();
  }, [userRole, youtubeList, languages]);

  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  //-------------------------- when pressing comma "," add new genre

  const createOption = (label) => ({
    label,
    value: label,
    __isNew__: true,
  });

  const capitalizeWords = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleKeyDownSubCategory = (event) => {
    if (!inputValueSubCategory) return;
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        break;
      case "Tab":
      case ",":
        const capitalizedInput = capitalizeWords(inputValueSubCategory.trim());

        setSubCategoryValue(createOption(capitalizedInput));
        setInputSubCategoryValue("");

        event.preventDefault();
    }
  };

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        break;
      case "Tab":
      case ",":
        const capitalizedInput = capitalizeWords(inputValue.trim());
        // Check if the capitalizedInput already exists in the genreValue or genres arrays
        const isDuplicateInTagValue = genreValue.some(
          (option) =>
            option.label.toLowerCase() === capitalizedInput.toLowerCase()
        );

        const isDuplicateInTags = genres.some(
          (genre) =>
            genre.label.toLowerCase() === capitalizedInput.toLowerCase()
        );

        if (
          !isDuplicateInTagValue &&
          !isDuplicateInTags &&
          inputValue !== ","
        ) {
          setGenreValue((prev) => [...prev, createOption(capitalizedInput)]);
          setInputValue("");
        }
        // setGenreValue((prev) => [...prev, createOption(capitalizedInput)]);
        // setInputValue("");
        // console.log("tagvlaue key down", genreValue);
        event.preventDefault();
    }
  };

  const onRemoveItem = (action) => {
    if (action.action === "remove-value" || action.action === "pop-value") {
      const updatedTags = genreValue.filter(
        (item) => item.label !== action.removedValue.label
      );
      setGenreValue(updatedTags);
      console.log("remove", updatedTags);
    }

    if (action.action === "clear") {
      setGenreValue([]);
    }
  };

  let filteredOptions = [];
  const handleDropdownOptions = () => {
    const savedGenres = genres;
    const newGenres = genreValue;
    const mergedGenres = [...savedGenres, ...newGenres];
    // console.log("mergedGenres", mergedGenres);

    let filteredOptions = [];
    const youtubeGenreLabels = new Set(
      mergedGenres?.map((genre) => genre.label.toLowerCase())
    );
    const filteredTagDropDownOptions = tagDropDownOptions?.filter(
      (item) => !youtubeGenreLabels.has(item.label.toLowerCase())
    );

    // console.log("filteredOptions", filteredTagDropDownOptions);
    filteredOptions = filteredTagDropDownOptions;
    return filteredOptions;
  };

  filteredOptions = handleDropdownOptions();

  const isValidNewOption = (inputValue, selectValue, selectOptions) => {
    const savedGenres = genres; // existing genres of the video
    const newGenres = genreValue; // new genres
    const mergedGenres = [...savedGenres, ...newGenres];

    // Normalize inputValue to lowercase for comparison
    const normalizedInputValue = inputValue.toLowerCase().trim();

    // Create a set of lowercase labels from mergedGenres for efficient lookup
    const youtubeGenreLabels = new Set(
      mergedGenres.map((genre) => genre.label.toLowerCase())
    );

    // Create a set of stop words for efficient lookup
    const stopWordsSet = new Set(COMMON_STOP_WORDS);

    // Check if inputValue exists in the stop words list
    if (stopWordsSet.has(normalizedInputValue)) {
      return false; // Disable creating new option if it matches a stop word
    }

    // Check if inputValue already exists in mergedGenres
    if (youtubeGenreLabels.has(normalizedInputValue)) {
      return false; // Disable creating new option if it already exists
    }

    // Allow creating new options for other values
    if (!youtubeGenreLabels.has(normalizedInputValue) && inputValue !== "") {
      return true;
    }
  };

  useEffect(() => {
    if (genreValue) {
      handleGenreChange(genreValue);
    }

    handleDropdownOptions();
  }, [genreValue]);

  useEffect(() => {
    if (subCategoryValue) {
      handleSubCategoryChange(subCategoryValue);
    }
  }, [subCategoryValue]);

  const isPlayListIncluded = youtubeList?.playlistTitle;
  const isStatusNotPublished = youtubeList?.status?.[0]?.status !== "Published";
  const isStatusNotReviewed = youtubeList?.status?.[0]?.status !== "Reviewed";

  //--------------------------handle string size
  const maxCharLength = 125;

  const getTrimmedText = (text, maxLength) => {
    if (text?.length <= maxLength) {
      // console.log("text is available", text);
      return text;
    }

    const trimmedText = text?.substr(0, text?.lastIndexOf(" ", maxLength));
    // console.log(trimmedText);

    // If no space is found, return the first maxLength characters
    return trimmedText ? trimmedText : text?.substr(0, maxLength);
  };

  //--------------------------handle read more
  const [showFullContent, setShowFullContent] = useState({}); //handle using key's

  const handleOnClickReadMore = (key) => {
    // Toggle the value for the given key
    setShowFullContent((prevState) => ({
      ...prevState,
      [key]: !prevState[key], // Toggle the value for this specific key
    }));
  };

  const readMoreButton = (key) => {
    return (
      <ButtonView
        title={!showFullContent[key] ? "Read more" : "Read less"}
        onClick={() => handleOnClickReadMore(key)}
        styles={"secondary"}
        extraStyles={"extras-btn"}
        size={"small"}
      />
    );
  };

  const title = (
    <>
      {/* <div className="item-wrapper fit-content-height"> */}
      <div className={`item-wrapper fit-content-height`}>
        <span className="label-wrapper">Title:</span>
        <span className="partition"></span>
        {/* <span className="field-wrapper title">{youtubeList?.title}</span> */}
        <span className="content-wrapper">
          <span
            className={`field-wrapper ${
              showFullContent?.title ? "full-content" : "text-clip-wrapper"
            }`}
          >
            {showFullContent?.title
              ? youtubeList?.title
              : getTrimmedText(youtubeList?.title, maxCharLength)}
          </span>
          <span
            className={`action-wrapper ${
              youtubeList?.title?.length <= maxCharLength && "d-none" //hide read more button
            }`}
          >
            {readMoreButton("title")}
          </span>
        </span>
      </div>
    </>
  );

  const channelName = (
    <>
      <div className="item-wrapper fit-content-height">
        <span className="label-wrapper">Channel:</span>
        <span className="partition"></span>
        {/* <span className="field-wrapper title">{youtubeList?.channelTitle}</span> */}
        <span className="content-wrapper">
          <span
            className={`field-wrapper ${
              showFullContent?.Channel ? "full-content" : "text-clip-wrapper"
            }`}
          >
            {showFullContent?.Channel
              ? youtubeList?.channelTitle
              : getTrimmedText(youtubeList?.channelTitle, maxCharLength)}
          </span>
          <span
            className={`action-wrapper ${
              youtubeList?.channelTitle?.length <= maxCharLength && "d-none" //hide read more button
            }`}
          >
            {readMoreButton("Channel")}
          </span>
        </span>
      </div>
    </>
  );

  const playlist = (
    <>
      <div className="item-wrapper fit-content-height">
        <span className="label-wrapper">Playlist:</span>
        <span className="partition"></span>
        <span className="field-wrapper">{youtubeList?.playlistTitle}</span>
      </div>
    </>
  );

  const type = (
    <>
      <div className="item-wrapper fit-content-height">
        <span className="label-wrapper">Type:</span>
        <span className="partition"></span>
        <span className="field-wrapper">{youtubeList?.contentType}</span>
      </div>
    </>
  );

  // const category = (
  //   <>
  //     {youtubeList?.contentType !== "Shorts" && (
  //       <div className="item-wrapper fit-content-height">
  //         <span className="label-wrapper">Category:</span>
  //         <span className="partition"></span>
  //         <span className="field-wrapper">
  //           {(isStatusNotPublished && isStatusNotReviewed) ||
  //           userPermissions?.includes("manage_category") ? (
  //             <Select
  //               name="category"
  //               isDisabled={
  //                 youtubeList?.status?.[0]?.status === "Published" &&
  //                 youtubeList?.categoryId?.[0]?.categoryName &&
  //                 true
  //               }
  //               value={fields["category"] || null}
  //               placeholder={"Please select category"}
  //               isrequired={
  //                 youtubeList?.status?.[0]?.status === "Published"
  //                   ? false
  //                   : true
  //               }
  //               options={categoryDropDownOptions}
  //               onChange={handleCategoryChange}
  //               // placeholder="Please select category"
  //               error={errors["category"]}
  //             />
  //           ) : (
  //             // <span> {youtubeList?.categoryId?.[0]?.categoryName}</span>
  //             <span> {youtubeList?.categoryId?.categoryName}</span>
  //           )}
  //         </span>
  //       </div>
  //     )}
  //   </>
  // );

  const dropdownOrInputRenderingForEditor =
    editor && fields["status"]?.label === "Published";

  console.log(
    "dropdownOrInputRenderingForEditor",
    dropdownOrInputRenderingForEditor
  );

  const category = (
    <>
      {youtubeList?.contentType === "Shorts" ? (
        // Show the category name directly if contentType is "Shorts"
        <div className="item-wrapper fit-content-height">
          <span className="label-wrapper">Category:</span>
          <span className="partition"></span>
          <span className="field-wrapper">
            <span>
              {
                categoryDropDownOptions
                  ?.filter((item) => item?.label === "Shorts")
                  .map((item) => item.label) // Extract and render the label from the filtered item
              }
            </span>
          </span>
        </div>
      ) : (
        // Show the Select dropdown for other content types
        <div className="item-wrapper fit-content-height">
          <span className="label-wrapper">Category:</span>
          <span className="partition"></span>
          <span className="field-wrapper">
            {(isStatusNotPublished && isStatusNotReviewed) ||
            (userPermissions?.includes("manage_category") &&
              !dropdownOrInputRenderingForEditor) ? (
              <Select
                name="category"
                isDisabled={
                  youtubeList?.status?.[0]?.status === "Published" &&
                  youtubeList?.categoryId?.[0]?.categoryName
                }
                value={fields["category"] || null}
                placeholder={"Please select category"}
                isrequired={
                  youtubeList?.status?.[0]?.status === "Published"
                    ? false
                    : true
                }
                options={categoryDropDownOptions}
                onChange={handleCategoryChange}
                error={errors["category"]}
              />
            ) : (
              <span>{youtubeList?.categoryId?.categoryName}</span>
            )}
          </span>
        </div>
      )}
    </>
  );

  const browseThumbnail = (
    <>
      <div className="item-wrapper fit-content-height">
        <span className="label-wrapper">Thumbnail:</span>
        <span className="partition"></span>
        <span className="field-wrapper">
          {userPermissions?.includes("manage_category") ? (
            <>
              <FileInput
                id="choose-thumbnail"
                type={"file"}
                accept="image/*"
                onChange={(e) => handleFileChange(e)}
                hidden
              />
              <div className="file-input-wrapper">
                <label
                  htmlFor="choose-thumbnail"
                  className="upload-file-action"
                >
                  Choose File
                </label>
                <span
                  className={`file-desc-block ${
                    !fields?.file && !fields?.fileURL?.fileName
                      ? "placeholder-text"
                      : ""
                  }`}
                  onClick={() =>
                    (fields?.file || fields?.fileURL?.fileName) &&
                    onClickImageTitle()
                  }
                >
                  {fields?.file?.name ||
                    fields?.fileURL?.fileName ||
                    "No file chosen"}
                </span>
                {/* <span className="file-action-block"> */}
                {/* {fields?.file && (
                    <ButtonView
                      // title="Add Action"
                      icon={<MdDelete title="Delete" />}
                      styles={"danger-outline extra-danger-styles"}
                      extraStyles={"extra-style remove-action-btn"}
                      onClick={() => onClickDeleteFile()}
                    />
                  )} */}
                {/* </span> */}
              </div>
            </>
          ) : (
            <span
              className={`viewer-only-block`}
              // onClick={() => fields?.file && onClickImageTitle()}
              onClick={() => onClickImageTitle()}
            >
              {/* {fields?.file ? fields?.file?.name : "No file chosen"} */}

              <ButtonView
                // icon={<FaEye />}
                title="View Image"
                styles={"secondary extra-secondary-styles"}
                extraStyles={"extra-style view-action-btn"}
                onClick={() => onClickImageTitle()}
              />
            </span>
          )}
        </span>
      </div>
    </>
  );

  const genre = (
    <>
      {/* <div className="item-wrapper wrapper-full-height tag-wrapper fit-content-height"> */}
      <div className="item-wrapper fit-content-height">
        <span className="label-wrapper">Genre:</span>
        <span className="partition"></span>
        {userPermissions?.includes("manage_tag") &&
        !dropdownOrInputRenderingForEditor ? (
          <>
            <span className="field-wrapper tag">
              <TagView
                name="genre"
                classNamePrefix={
                  genreValue?.length > 0 ? "tag-menu-active" : ""
                }
                value={genreValue}
                isrequired={true}
                isMulti={true}
                isSearchable={true}
                placeholder={"Please add genre"}
                options={filteredOptions}
                handleKeyDown={handleKeyDown}
                inputValue={inputValue}
                onInputChange={(newValue) => {
                  setInputValue(newValue);
                }}
                onChange={(val, action) => {
                  handleGenreChange(val);
                  setGenreValue([...genreValue, val.slice(-1)[0]]);
                  onRemoveItem(action);
                }}
                isValidNewOption={isValidNewOption}
                error={errors["genre"]}
              />
            </span>
          </>
        ) : (
          // <span className="field-wrapper tag-list-text">
          //   {genres.map((genre) => genre.label).join(", ")}
          // </span>
          <span className="content-wrapper">
            <span
              className={`field-wrapper ${
                showFullContent?.Genre ? "full-content" : "text-clip-wrapper"
              }`}
            >
              {/* {fields?.metaData} */}

              {showFullContent?.Genre
                ? genres.map((genre) => genre.label).join(", ")
                : getTrimmedText(
                    genres.map((genre) => genre.label).join(", "),
                    maxCharLength
                  )}
            </span>
            <span
              className={`action-wrapper ${
                genres.map((genre) => genre.label).join(", ")?.length <=
                  maxCharLength && "d-none" //hide read more button
              }`}
            >
              {readMoreButton("Genre")}
            </span>
          </span>
        )}
      </div>
    </>
  );

  const renderGenreList = () => {
    return (
      <>
        <div className={`item-wrapper genre-list-content-wrapper`}>
          {genres?.map((item, index) => (
            <span className="genre-content">
              <span className="content">
                {item.label ? item.label : item.tag}
              </span>
              <span className="ms-1">
                {/* only  show remove option when show selection is false*/}
                {userPermissions?.includes("manage_tag") && !showSelection && (
                  <MdClose
                    onClick={() => {
                      handleRemoveGenre(index);
                      console.log(index);
                    }}
                  />
                )}
              </span>
            </span>
          ))}
        </div>
      </>
    );
  };

  const metaData = (
    <>
      {/* <div className="item-wrapper wrapper-full-height tag-wrapper fit-content-height"> */}
      <div className="item-wrapper fit-content-height">
        <span className="label-wrapper">Meta-Data:</span>
        <span className="partition"></span>
        {userPermissions?.includes("manage_tag") &&
        !dropdownOrInputRenderingForEditor ? (
          <>
            <span className="field-wrapper tag-input-field aligning-wrapper">
              <Input
                name="metaData"
                extraStyle={"text-block-input"}
                value={fields?.metaData}
                isrequired={true}
                placeholder={"Please enter meta-data"}
                onChange={(e) => handleInputChange(e)}
                error={errors["metaData"]}
                autoComplete="off"
              />
            </span>
          </>
        ) : (
          <span className="content-wrapper">
            <span
              className={`field-wrapper ${
                showFullContent?.MetaData ? "full-content" : "text-clip-wrapper"
              }`}
            >
              {/* {fields?.metaData} */}

              {showFullContent?.MetaData
                ? fields?.metaData
                : getTrimmedText(fields?.metaData, maxCharLength)}
            </span>
            <span
              className={`action-wrapper ${
                fields?.metaData?.length <= maxCharLength && "d-none" //hide read more button
              }`}
            >
              {readMoreButton("MetaData")}
            </span>
          </span>
        )}
      </div>
    </>
  );

  const language = (
    <>
      <div className="item-wrapper fit-content-height">
        <span className="label-wrapper">Language:</span>
        <span className="partition"></span>
        <span className="field-wrapper">
          {userPermissions?.includes("update_content_language") &&
          !dropdownOrInputRenderingForEditor ? (
            <Select
              name="language"
              value={fields["language"]}
              isrequired={true}
              isSearchable={true}
              options={LanguagesDropDownOptions}
              placeholder={"Please select language"}
              onChange={handleLanguageChange}
              error={errors["language"]}
            />
          ) : (
            // youtubeList?.languageId?.[0]?.name
            youtubeList?.languageId?.name
          )}
        </span>
      </div>
    </>
  );

  const status = (
    <>
      <div className="item-wrapper fit-content-height">
        <span className="label-wrapper">Status:</span>
        <span className="partition"></span>
        <span className="field-wrapper">
          {userPermissions?.includes("update_content_status") &&
          !dropdownOrInputRenderingForEditor ? (
            <Select
              name="status"
              isrequired={true}
              options={statusDropDownOptions}
              value={fields["status"]}
              placeholder={"Please select status"}
              onChange={handleStatusChange}
              error={errors["status"]}
              // isDisabled={editor && fields["status"]?.label === "Published"}
            />
          ) : (
            youtubeList?.status?.[0]?.status
          )}
        </span>
      </div>
    </>
  );

  const buttons = userPermissions?.includes("youtube_content_submit") && (
    <>
      <span className="action-btn">
        <ButtonView
          title={!dropdownOrInputRenderingForEditor ? "Cancel" : "Go Back"}
          onClick={() => onClickCancelButton()}
          styles={"light"}
          size={"large"}
        />
      </span>
      {!dropdownOrInputRenderingForEditor && (
        <span className="action-btn">
          <ButtonView
            title="Submit"
            onClick={() => {
              const isPublished =
                fields?.status?.label === "Published" ? true : false;
              // console.log("isPublished", isPublished);

              const tagLabels =
                youtubeList?.tag
                  ?.filter((item) => item?.tag !== undefined)
                  ?.map((item) => item.tag) || [];

              const data = {
                category: youtubeList?.categoryId?.[0]?._id,
                tag: [tagLabels],
                status: youtubeList?.status?.[0]?._id,
                language: youtubeList?.languageId[0]?._id,
              };
              console.log("submit data", data);
              onClickContentDetailsSubmit(youtubeList?._id, isPublished, data);
            }}
            styles={"secondary"}
            size={"large"}
          />
        </span>
      )}
      {ENABLE_NOTIFY_USERS &&
        !dropdownOrInputRenderingForEditor &&
        youtubeList?.status?.[0]?.status === "Published" && (
          <span className="action-btn">
            <ButtonView
              title="Notify Users"
              onClick={() => {
                onClickSendNotification();
              }}
              styles={"secondary"}
              size={"large"}
            />
          </span>
        )}
    </>
  );

  //--------------------------send notification modal UI
  const renderSendNotificationBody = () => {
    return (
      <div className="body__wrapper--notification-block">
        <div className="mb-3">
          <Input
            label={"Title"}
            value={fields?.title}
            onChange={(e) => {
              handleTitleChange(e);
            }}
            placeholder="Please enter title"
          />
        </div>
        <div className="mb-3 content-text-area">
          <TextArea
            label={"Description"}
            value={fields?.description}
            onChange={(e) => handleDescriptionChange(e)}
            placeholder="Please enter description"
          />
        </div>
        <div className="image-block">
          <img
            className="image"
            src={fields?.thumbnail || backgroundImagePlaceholder}
          />
        </div>
      </div>
    );
  };

  const renderSendNotificationFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            size={"large"}
            onClick={handleCloseModal}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Send"
            styles={"secondary"}
            size={"large"}
            onClick={() => {
              onClickNotify();
            }}
            disabled={!fields?.title ? true : false}
          />
        </div>
      </div>
    );
  };

  //--------------------------View Image modal UI
  const renderShowImageBody = () => {
    return (
      <div className="body-content-wrapper-render-image">
        <div className="image-block">
          <span className="close-icon" onClick={() => handleCloseModal()}>
            <MdClose size={20} color="black" />
          </span>
          <img
            className="image"
            src={fields?.fileURL?.thumbnailPath || fields?.fileURL}
          />
        </div>
      </div>
    );
  };

  const renderEditFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          {/* <ButtonView
          title="Cancel"
          styles={"light"}
          size={"large"}
          onClick={handleCloseModal}
        /> */}
        </div>
        <div className="action-wrapper">
          {/* <ButtonView
          title="Update"
          styles={"secondary"}
          size={"large"}
          onClick={() => onClickEditUserSubmit(userData?._id)}
        /> */}
        </div>
      </div>
    );
  };

  //--------------------------Delete modal UI
  const renderDeleteBody = () => {
    return (
      <div className="body-content-wrapper delete-body">
        <div>Are you sure you want to delete this image?</div>
      </div>
    );
  };

  const renderDeleteFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="No"
            styles={"light"}
            size={"medium"}
            onClick={handleCloseModal}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Yes"
            styles={"danger"}
            size={"medium"}
            onClick={() => handleRemoveFile()}
          />
        </div>
      </div>
    );
  };

  const renderConditionsForEditorRole = {
    categoryCondition:
      editor &&
      !youtubeList?.categoryId?.categoryName &&
      fields["status"]?.label === "Published",
    GenreCondition:
      editor && genres?.length === 0 && fields["status"]?.label === "Published",
    metaDataCondition:
      editor &&
      !youtubeList?.stringTags &&
      fields["status"]?.label === "Published",
    languageCondition:
      editor &&
      !youtubeList?.languageId?.name &&
      fields["status"]?.label === "Published",
    statusCondition:
      editor &&
      !youtubeList?.status?.[0]?.status &&
      fields["status"]?.label === "Published",
  };

  return (
    <div className="content__management__youtube--container">
      <div className="content__management__youtube--header-wrapper">
        <div className="action">
          <FaArrowLeftLong size={25} onClick={onClickCancel} />
        </div>
        <div className="title-content">Content Details</div>
      </div>
      <div className="content__management__youtube--content-details-wrapper">
        <div className="video-player-block">
          {youtubeList?.videoId && (
            <YouTube videoId={youtubeList?.videoId} opts={opts} />
          )}
        </div>
        <div className="text-content-block">
          <div className="text-field-block">
            {title}

            {activeNavTab !== youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL &&
              channelName}

            {isPlayListIncluded && playlist}

            {viewOnly && !youtubeList?.contentType ? null : type}

            {/* {viewOnly && !youtubeList?.categoryId?.[0]?.categoryName
              ? null
              : category} */}

            {(viewOnly && !youtubeList?.categoryId?.categoryName) ||
            renderConditionsForEditorRole?.categoryCondition
              ? null
              : category}

            {/* {viewOnly && !youtubeList?.customParameters
              ? null
              : browseThumbnail} */}

            {(viewOnly && genres?.length === 0) ||
            renderConditionsForEditorRole?.GenreCondition ? null : (
              <div className="genre-list-block">
                {genre}
                {genres.length > 0 &&
                userPermissions?.includes("manage_tag") &&
                !dropdownOrInputRenderingForEditor
                  ? renderGenreList()
                  : null}
              </div>
            )}

            {(viewOnly && !youtubeList?.stringTags) ||
            renderConditionsForEditorRole?.metaDataCondition
              ? null
              : metaData}

            {/* {viewOnly && !youtubeList?.languageId?.[0]?.name ? null : language} */}

            {(viewOnly && !youtubeList?.languageId?.name) ||
            renderConditionsForEditorRole?.languageCondition
              ? null
              : language}

            {(viewOnly && !youtubeList?.status?.[0]?.status) ||
            renderConditionsForEditorRole?.statusCondition
              ? null
              : status}
          </div>
          <div className="action-wrapper">{buttons}</div>
        </div>
      </div>
      <ModalView
        show={showModal.showSendNotificationModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={false}
        title={"Send notification to users"}
        children={renderSendNotificationBody()}
        footer={renderSendNotificationFooter()}
        size={"md"}
      />
      <ModalView
        show={showModal.showImageModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={false}
        // title={"Thumbnail Image"}
        children={renderShowImageBody()}
        // footer={renderEditFooter()}
        isImageModal={true}
        size={"md"}
      />
      <ModalView
        show={showModal.showDeleteModal}
        handleClose={handleCloseModal}
        modalHeaderStyles={"delete-modal-header"}
        modalBodyStyles={"delete-modal-body"}
        modalFooterStyles={"delete-modal-footer"}
        center={true}
        showCloseIcon={true}
        title={"Delete"}
        children={renderDeleteBody()}
        footer={renderDeleteFooter()}
      />
    </div>
  );
};

export default ContentDetailsView;
